import getBlob from 'api/file/services/getBlob';

export default { getBlob };
